import { FC, useEffect, useState } from "react";

import { Button, Stack } from "@mui/material";
import { CheckPayRollModel } from "../Commission";

interface CommissionPayRollStatusProps {
    checkPayRoll: CheckPayRollModel[];
    LoadPayroll: () => void;
}

const CommissionPayRollStatus: FC<CommissionPayRollStatusProps> = ({ checkPayRoll, LoadPayroll }) => {
    if (checkPayRoll.length === 0)
        return (<></>);

    const [disableButton, setDisableButton] = useState<boolean>(true);

    useEffect(() => {
        setDisableButton(checkPayRoll.every(x => x.hasPayRoll))
    }, [checkPayRoll])

    return (

        <Stack
            direction="column"
            spacing={1}
            alignItems="center"
            sx={{ marginBottom: "50px" }}>
            <span style={{ fontSize: "18px", fontWeight: "600" }}>Payroll Status</span>

            {checkPayRoll.map((item, index) => (
                <p key={index}>{item.salesman}: {item.hasPayRoll ? "Yes" : "No"}</p>
            ))}

            <Button
                variant="outlined"
                disabled={disableButton}
                onClick={LoadPayroll}>
                Create payroll
            </Button>
        </Stack>

    )
}

export default CommissionPayRollStatus;